import React from 'react';
import HomeOwnerErip from "../../../components/pages/form/HomeOwnerErip/HomeOwnerErip";

const HomeOwnerEripPage = () => {
    return <HomeOwnerErip />
};

export default HomeOwnerEripPage;
